import React, {Component} from "react";
import { Button, Input } from 'theme-ui'
import styled from '@emotion/styled'

const FormGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
const FormButton = styled(Button)`
    background: ${props=>props.theme.colors.accent_red};
    color: #FFF;
    padding: 0.5em 2em;
    border-radius: 0;
    text-transform: uppercase;
    font-weight: normal;
`
const FormInput = styled(Input)`
    flex: 1;
    border: none;
    border-radius: 0;
    padding: 0.5em 1em;
    max-width: 400px;
    font-weight: normal;
    background: #FFF;
    color: ${props=>props.theme.colors.secondary};
`
const Message = styled.span`
    color: #FFF;
`
class Signup extends Component {
    componentDidMount() {
        (function() {
            var cesa = document.createElement('script');
            cesa.type = 'text/javascript';
            cesa.async = true;
            cesa.src = 'https://static.ctctcdn.com/h/contacts-embedded-signup-assets/1.0.2/js/signup-form.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(cesa, s);

            var vs = document.createElement('script');
            vs.type = 'text/javascript';
            vs.async = true;
            vs.src = '/validations.js';
            s.parentNode.insertBefore(vs, s);
        })();
    }
    render() {
        return(
            <>
            <form data-id="embedded_signup:form" name="embedded_signup" method="POST" action="https://visitor2.constantcontact.com/api/signup">
                <input data-id="ca:input" name="ca" value="6208f27b-e026-497c-87bc-7ada3990ee12" type="hidden" />
                <input data-id="list:input" name="list" value="1488683292" type="hidden" />
                <input data-id="source:input" name="source" value="EFD" type="hidden" />
                <input data-id="required:input" name="required" value="list,email" type="hidden" />
                <input data-id="url:input" name="url" value="" type="hidden" />
                <FormGroup data-id="Email Address:p">
                    <FormInput data-id="Email Address:input" placeholder="Enter email" aria-label="Enter email" aria-describedby="basic-addon2" name="email" maxlength="80" type="text" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
                    <FormButton type="submit" id="button-addon2" role="button" data-enabled="enabled">Subscribe</FormButton>
                </FormGroup>
            </form>
            <Message id="success_message" style={{display:"none"}}>
                <div style={{textAlign:"left"}}>Thanks for signing up!</div>
            </Message>
            </>
        )
    }
}

export default Signup
